import l from '../../../../lang';
import Dialog from '../../../common/dialog';
import { Urls } from '../../../../config/urls';
import { getLanguage, openNewTabAndFocus } from '../../../../utils';

interface RejectionReasonModalProps {
    endUserErrorType: string;
    onClose: () => void;
}

const RejectionReasonModal = ({ endUserErrorType, onClose }: RejectionReasonModalProps) => {
    const translationKey = `checkout-logs.type.${endUserErrorType}`;
    const translatedReason = l(translationKey);
    const displayReason = translatedReason === translationKey ? endUserErrorType : translatedReason;

    const helpUrl = Urls.checkoutLogsHelp[getLanguage()];

    return (
        <Dialog
            title={l('transactions.rejectionReason.title')}
            handleClose={onClose}
            body={
                <div className="rejection-reason-modal">
                    <p className="rejection-reason-modal__reason">{displayReason}</p>
                    <a
                        className="rejection-reason-modal__help-link"
                        onClick={e => {
                            e.preventDefault();
                            openNewTabAndFocus(helpUrl);
                        }}
                        style={{ cursor: 'pointer' }}
                    >
                        {l('checkout-logs.tooltip.help')}
                    </a>
                </div>
            }
        />
    );
};

export default RejectionReasonModal;
